import React, { useState } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig";
import { adminLogin } from "./adminApi";

interface LoginScreenProps {
  DEV_MODE: boolean;
  onDevLogin: () => void;
}

const LoginScreen: React.FC<LoginScreenProps> = ({ DEV_MODE, onDevLogin }) => {
  const { instance } = useMsal();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      if (DEV_MODE) {
        const success = await adminLogin(username, password);
        if (success) {
          onDevLogin();
        } else {
          setError("Invalid login or password");
        }
      } else {
        instance.loginPopup(loginRequest).catch((err) => {
          console.error(err);
        });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-screen">
      <div className="login-card">
        <form onSubmit={handleLogin}>
          <div className="form-group">
            <label htmlFor="username">Login</label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter your login"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
            />
          </div>

          <button type="submit" disabled={loading}>
            {loading ? "Signing in..." : "Sign in"}
          </button>

          {error && <p style={{ color: "#e74c3c", marginTop: "10px", textAlign: "center" }}>{error}</p>}
        </form>

        {!DEV_MODE && (
          <div className="alt-login">
            <p>or</p>
            <button type="button" onClick={() => instance.loginPopup(loginRequest)}>
              Sign in with Microsoft
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default LoginScreen;
